import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { Helmet } from 'react-helmet-async';

import messages from './messages';

const HtmlHead = ({ intl }) => (
  <Helmet
    title={intl.formatMessage(messages.metaTitle)}
    meta={[
      {
        name: 'description',
        content: intl.formatMessage(messages.metaDescription),
      },
    ]}
    link={[
      {
        rel: 'shortcut icon',
        href:
          'https://www.xing.com/assets/frontend_minified/img/shared/xing_r1.ico',
        type: 'image/ico',
      },
      {
        rel: 'apple-touch-icon',
        href:
          'https://www.xing.com/assets/frontend_minified/img/shared/xing_icon_apple.png',
      },
    ]}
  />
);

HtmlHead.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(HtmlHead);
